import { render, staticRenderFns } from "./TranscriptOverview.vue?vue&type=template&id=b3d38e48&"
import script from "./TranscriptOverview.vue?vue&type=script&lang=js&"
export * from "./TranscriptOverview.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports